<script>
    import { fly } from "svelte/transition";
    import { Steps, Step,Checked,Uncheck,Plus,Button } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>

    <h4 class="example-title">纵向步骤条</h4>
    <div class="example-body nopadding">
        <Steps current={1}>
            <Step title="填写机构信息" status="process"/>
            <Step title="签约机构" />
            <Step title="关联服务区" />
        </Steps>
    </div>

    <h4 class="example-title">纵向步骤条失败</h4>
    <div class="example-body nopadding">
        <Steps>
            <Step title="填写机构信息" status="finish" />
            <Step title="签约机构" status="error" />
            <Step title="关联服务区" />
        </Steps>
    </div>
    <h4 class="example-title">纵向步骤条带描述</h4>
    <div class="example-body nopadding">
        <Steps>
            <Step title="填写机构信息" status="finish"
                >完成时间：2020-12-01 12:30</Step
            >
            <Step title="签约机构" status="process"
                >
                <div>完成时间：2020-12-01 12:30</div>
                </Step
            >
            <Step title="关联服务区">完成时间：2020-12-01 12:30</Step>
        </Steps>
    </div>
    <h4 class="example-title">横向步骤条</h4>
    <div class="example-body nopadding">
        <Steps direction="horizontal">
            <Step title="填写机构信息" status="process" />
            <Step title="签约机构" />
            <Step title="关联服务区" />
        </Steps>
    </div>

    <h4 class="example-title">横向步骤条失败</h4>
    <div class="example-body nopadding">
        <Steps direction="horizontal">
            <Step title="填写机构信息" status="finish" />
            <Step title="签约机构" status="process" />
            <Step title="关联服务区" status="error" />
        </Steps>
    </div>
    <h4 class="example-title">横向步骤条带描述</h4>
    <div class="example-body nopadding">
        <Steps direction="horizontal">
            <Step title="填写机构信息" status="finish">2020-12-01 12:30</Step>
            <Step title="签约机构" status="process">2020-12-01 12:30</Step>
            <Step title="关联服务区">2020-12-01 12:30</Step>
        </Steps>
    </div>

    <h4 class="example-title">横向步骤条带描述</h4>
    <div class="example-body nopadding">
        <Steps>
            <Step title="填写机构信息" status="finish">
                <Checked slot="icon" size={20}/>
                2020-12-01 12:30</Step>
            <Step title="签约机构" status="process">
                <Checked slot="icon" size={20}/>
                <div>2020-12-01 12:30</div>
                <br>
                <Button color="primary">去查看</Button>
            </Step>
            <Step title="关联服务区">
                <Checked slot="icon" color="gray" size={20}/>
                2020-12-01 12:30</Step>
        </Steps>
    </div>
</div>

<style lang="less">
    @import "./example.less";
    .nopadding {
        padding: 0;
    }
</style>
